import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  createCashRegister,
  createPartsPriceCategory,
  createEmployee,
  createMarkup,
  createPost,
  createPartsService,
  createSupplier,
  deleteCashRegister,
  deleteEmployee,
  deleteMarkup,
  deletePost,
  deleteSupplier,
  getAllCashRegisters,
  getAllEmployees,
  getAllMarkups,
  getAllSuppliers,
  // getCashRegisterData,
  getPosts,
  getPartsPrices,
  // getPricesInCategory,
  getRatings,
  // getWorkSchedule,
  updateCashRegister,
  updatePartsServiceOrCategory,
  // updateCategoryData,
  updateEmployeeData,
  updateEmployeeStatus,
  updateFixedMarkup,
  updatePostData,
  updateSupplierData,
  // updateWorkSchedule,
  getServicesPrices,
  addServicesSubcategory,
  deleteDiagnosticCategory,
  updateDiagnosticCategory,
  deletePartsServiceOrCategory,
  registerNewService,
  testSupplierConnection,
  getEmployeeFormData,
  getOtherServicesPrices,
  deleteOtherServiceOrCategory,
  createOtherServicesPriceCategory,
  createOtherServicesService,
  updateOtherServicesCategoryOrService,
  uploadOtherServicesPrices,
  getAllMechanics,
  getPermissionsList,
  getPermissionsListByRole,
  uploadPartsPrices,
  getIntegration,
  createIntegration,
  updateIntegration,
  deleteIntegration,
  testIntegration,
  resetIntegrationApiKey,
  getSupplierWarehouses,
  getLicense,
  requestLicenseKey,
  deleteRecord,
  deleteAllRecords,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const settingsSlice = createSlice({
  name: "settings",
  initialState: initialState.settings,
  reducers: {
    // setEditedCategory: (state, action) => {
    //   if (!action.payload || Object.keys(action.payload).length === 0) {
    //     return;
    //   }
    //   const { id, name } = action.payload;
    //   const existingCategory = state.editedServices.find(c => c.id === id);
    //   if (existingCategory) {
    //     existingCategory.name = name;
    //   } else {
    //     state.editedServices.push({ id, name });
    //   }
    // },
    // setEditedService: (state, action) => {
    //   if (!action.payload || Object.keys(action.payload).length === 0) {
    //     return;
    //   }
    //   const editedService = action.payload;
    //   const index = state.editedServices.findIndex(
    //     s => s.service_id === editedService.service_id
    //   );
    //   if (index !== -1) {
    //     state.editedServices[index] = editedService;
    //   } else {
    //     state.editedServices.push(editedService);
    //   }
    // },
    setEditedItem: (state, action) => {
      if (!action.payload || !action.payload.id) return;

      const updatedItem = action.payload;

      const index = state.editedServices.findIndex(
        item => item.id === updatedItem.id
      );

      if (index !== -1) {
        state.editedServices[index] = {
          ...state.editedServices[index],
          ...updatedItem,
        };
      } else {
        state.editedServices.push(updatedItem);
      }
    },
    resetEditedServices: state => {
      state.editedServices = [];
    },
    openModal: state => {
      state.isModalOpen = true;
    },
    closeModal: state => {
      state.isModalOpen = false;
    },
    setTutorialSection: (state, action) => {
      state.tutorialSection = action.payload;
    },
    setSettingsPage: (state, action) => {
      state.settingsPage = action.payload;
    },
    setFinishedPages: (state, action) => {
      state.finishedPages = action.payload;
    },
    setLegalPersonType: (state, action) => {
      state.legalPersonType = action.payload;
    },
    setIsServiceAccordionExpanded: (state, action) => {
      state.isServiceAccordionExpanded = action.payload;
    },
    setIsTutorialOpen: (state, action) => {
      state.isTutorialOpen = action.payload;
    },
  },
  extraReducers: builder =>
    builder
      //! EMPLOYEE
      // Get all employees data +
      .addCase(getAllEmployees.pending, handlePending)
      .addCase(getAllEmployees.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employees = action.payload.data;
      })
      .addCase(getAllEmployees.rejected, handleRejected)

      // Get all mechanics +
      .addCase(getAllMechanics.pending, handlePending)
      .addCase(getAllMechanics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mechanics = action.payload;
      })
      .addCase(getAllMechanics.rejected, handleRejected)

      // Create employee / user +
      .addCase(createEmployee.pending, handlePending)
      .addCase(createEmployee.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createEmployee.rejected, handleRejected)

      // Get data for employee create form +
      .addCase(getEmployeeFormData.pending, handlePending)
      .addCase(getEmployeeFormData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employeeFormData = action.payload;
      })
      .addCase(getEmployeeFormData.rejected, handleRejected)

      // Get Permissions List +
      .addCase(getPermissionsList.pending, handlePending)
      .addCase(getPermissionsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.permissionsList = action.payload;
      })
      .addCase(getPermissionsList.rejected, handleRejected)

      // Get permissions list by role +
      .addCase(getPermissionsListByRole.pending, handlePending)
      .addCase(getPermissionsListByRole.fulfilled, (state, action) => {
        state.isLoading = false;
        state.permissionsByRole = action.payload;
      })
      .addCase(getPermissionsListByRole.rejected, handleRejected)

      // Update employee data +
      .addCase(updateEmployeeData.pending, state => {
        state.isStaffUpdating = true;
      })
      .addCase(updateEmployeeData.fulfilled, (state, action) => {
        state.isStaffUpdating = false;
      })
      .addCase(updateEmployeeData.rejected, state => {
        state.isStaffUpdating = false;
      })

      // Delete employee +
      .addCase(deleteEmployee.pending, handlePending)
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.isLoading = false;
        console.log("action.meta.arg", action.meta.arg);
        state.employees = state.employees.filter(
          employee => employee.id !== action.meta.arg
        );
      })
      .addCase(deleteEmployee.rejected, handleRejected)

      .addCase(updateEmployeeStatus.pending, handlePending)
      .addCase(updateEmployeeStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const employeeToEditIndex = state.employees.findIndex(
          employee => employee.id === action.payload.id
        );

        state.employees[employeeToEditIndex].is_active =
          action.payload.is_active;
      })
      .addCase(updateEmployeeStatus.rejected, handleRejected)

      //! SUPPLIER
      // Get all suppliers list +
      .addCase(getAllSuppliers.pending, handlePending)
      .addCase(getAllSuppliers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.suppliers = action.payload;
      })
      .addCase(getAllSuppliers.rejected, handleRejected)

      // Get supplier warehouses +
      // Без глобального isLoading: лоадер у DistributorsPart розмонтовує модалку і запит повторюється
      .addCase(getSupplierWarehouses.fulfilled, (state, action) => {
        state.supplierWarehouses = action.payload;
      })
      .addCase(getSupplierWarehouses.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Create supplier +
      .addCase(createSupplier.pending, handlePending)
      .addCase(createSupplier.fulfilled, (state, action) => {
        state.isLoading = false;
        // if (action.payload.supplier_id) {
        //   state.suppliers.push(action.meta.arg);
        // } else {
        //   console.error("Supplier ID is undefined:", action.payload);
        // }
      })
      .addCase(createSupplier.rejected, handleRejected)

      // update supplier +
      .addCase(updateSupplierData.pending, handlePending)
      .addCase(updateSupplierData.fulfilled, (state, action) => {
        state.isLoading = false;

        const supplierToEditIndex = state.suppliers.findIndex(
          supplier => supplier.id === action.payload.id
        );

        state.suppliers[supplierToEditIndex] = {
          ...state.suppliers[supplierToEditIndex], // Залишаємо старі дані
          ...action.payload, // Додаємо дані, які відправляли
        };

        // // функція для оновлення даних по постачальнику
        // updateItem(state.suppliers, action.meta.arg, "supplier_id");
      })
      .addCase(updateSupplierData.rejected, handleRejected)

      // Delete supplier +
      .addCase(deleteSupplier.pending, handlePending)
      .addCase(deleteSupplier.fulfilled, (state, action) => {
        state.isLoading = false;
        // console.log("Deleted supplier:", action.payload);
        state.suppliers = state.suppliers.filter(
          supplier => supplier.id !== action.payload.id
        );
      })
      .addCase(deleteSupplier.rejected, handleRejected)

      // Test supplier connection
      .addCase(testSupplierConnection.pending, (state, action) => {
        state.isTestingSupplierConnection = true;
      })
      .addCase(testSupplierConnection.fulfilled, (state, action) => {
        state.isTestingSupplierConnection = false;
      })
      .addCase(testSupplierConnection.rejected, (state, action) => {
        state.isTestingSupplierConnection = false;
        state.error = action.payload;
      })

      //! SCHEDULE
      // .addCase(getWorkSchedule.pending, handlePending)
      // .addCase(getWorkSchedule.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.schedule = action.payload.days;
      // })
      // .addCase(getWorkSchedule.rejected, handleRejected)
      // .addCase(updateWorkSchedule.pending, handlePending)
      // .addCase(updateWorkSchedule.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.schedule = action.meta.arg.days;
      // })
      // .addCase(updateWorkSchedule.rejected, handleRejected)

      //! POSTS
      // Get list of all posts +
      .addCase(getPosts.pending, handlePending)
      .addCase(getPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.posts = action.payload;
      })
      .addCase(getPosts.rejected, handleRejected)

      // Create new post +
      .addCase(createPost.pending, handlePending)
      .addCase(createPost.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createPost.rejected, handleRejected)

      // Update post data +
      .addCase(updatePostData.pending, handlePending)
      .addCase(updatePostData.fulfilled, (state, action) => {
        state.isLoading = false;

        const postToEditIndex = state.posts.findIndex(
          post => post.id === action.payload.id
        );

        if (postToEditIndex !== -1) {
          const currentPost = state.posts[postToEditIndex];

          state.posts[postToEditIndex] = {
            ...currentPost,
            ...(action.payload.name_post && {
              name_post: action.payload.name_post,
            }),
            ...(action.payload.status !== undefined &&
              action.payload.status !== null && {
                status: action.payload.status,
              }),
          };
        }
      })

      .addCase(updatePostData.rejected, handleRejected)

      // Delete post +
      .addCase(deletePost.pending, handlePending)
      .addCase(deletePost.fulfilled, (state, action) => {
        state.isLoading = false;

        state.posts = state.posts.filter(post => post.id !== action.payload.id);
      })
      .addCase(deletePost.rejected, handleRejected)

      //! PRICE PART

      // Get categories and services for PricePart +
      .addCase(getPartsPrices.pending, handlePending)
      .addCase(getPartsPrices.fulfilled, (state, action) => {
        state.isLoading = false;

        state.partsPrices = action.payload;
      })
      .addCase(getPartsPrices.rejected, handleRejected)

      // Get services for Other Services Part +
      .addCase(getOtherServicesPrices.pending, handlePending)
      .addCase(getOtherServicesPrices.fulfilled, (state, action) => {
        state.isLoading = false;

        state.otherServicesPrices = action.payload;
      })
      .addCase(getOtherServicesPrices.rejected, handleRejected)

      // Update Parts category or service price +
      .addCase(updatePartsServiceOrCategory.pending)
      .addCase(updatePartsServiceOrCategory.fulfilled, (state, action) => {
        const updatedItem = action.payload;

        // 1️⃣ Якщо це батьківська категорія
        if (!updatedItem.parent_id) {
          const category = state.partsPrices.find(
            cat => cat.id === updatedItem.id
          );

          if (category) {
            Object.assign(category, updatedItem);
          }

          return;
        }

        // 2️⃣ Якщо це дочірній сервіс
        state.partsPrices.forEach(category => {
          if (category.children) {
            const service = category.children.find(
              child => child.id === updatedItem.id
            );

            if (service) {
              Object.assign(service, updatedItem);
            }
          }
        });
      })
      .addCase(updatePartsServiceOrCategory.rejected)

      // Update Other services category or service price +
      .addCase(updateOtherServicesCategoryOrService.pending)
      .addCase(
        updateOtherServicesCategoryOrService.fulfilled,
        (state, action) => {
          const updatedItem = action.payload;

          // 1️⃣ Якщо це батьківська категорія
          if (!updatedItem.parent_id) {
            const category = state.otherServicesPrices.find(
              cat => cat.id === updatedItem.id
            );

            if (category) {
              Object.assign(category, updatedItem);
            }

            return;
          }

          // 2️⃣ Якщо це дочірній сервіс
          state.otherServicesPrices.forEach(category => {
            if (category.children) {
              const service = category.children.find(
                child => child.id === updatedItem.id
              );

              if (service) {
                Object.assign(service, updatedItem);
              }
            }
          });
        }
      )
      .addCase(updateOtherServicesCategoryOrService.rejected)

      // Create parts price category +
      .addCase(createPartsPriceCategory.pending)
      .addCase(createPartsPriceCategory.fulfilled, (state, action) => {
        const newCategory = {
          children: [],
          ...action.payload,
        };

        state.partsPrices = [...state.partsPrices, newCategory];
      })
      .addCase(createPartsPriceCategory.rejected)

      // Create other services price category +
      .addCase(createOtherServicesPriceCategory.pending)
      .addCase(createOtherServicesPriceCategory.fulfilled, (state, action) => {
        const newCategory = {
          children: [],
          ...action.payload,
        };

        state.otherServicesPrices = [...state.otherServicesPrices, newCategory];
      })
      .addCase(createOtherServicesPriceCategory.rejected)

      // Create parts service +
      .addCase(createPartsService.pending)
      .addCase(createPartsService.fulfilled, (state, action) => {
        const { parent_id, ...newServiceData } = action.payload;

        const categoryToAddNewService = state.partsPrices.findIndex(
          category => category.id === parent_id
        );

        state.partsPrices[categoryToAddNewService].children.push(
          newServiceData
        );
      })
      .addCase(createPartsService.rejected)

      // Create Other services service +
      .addCase(createOtherServicesService.pending)
      .addCase(createOtherServicesService.fulfilled, (state, action) => {
        const { parent_id, ...newServiceData } = action.payload;

        const categoryToAddNewService = state.otherServicesPrices.findIndex(
          category => category.id === parent_id
        );

        state.otherServicesPrices[categoryToAddNewService].children.push(
          newServiceData
        );
      })
      .addCase(createOtherServicesService.rejected)

      // Delete service or category +
      .addCase(deletePartsServiceOrCategory.pending)
      .addCase(deletePartsServiceOrCategory.fulfilled, (state, action) => {
        const idToDelete = action.payload.id;

        state.partsPrices = state.partsPrices
          .filter(category => category.id !== idToDelete)
          .map(category => ({
            ...category,
            children:
              category.children?.filter(service => service.id !== idToDelete) ||
              [],
          }));
      })
      .addCase(deletePartsServiceOrCategory.rejected)

      // Delete Other service or category +
      .addCase(deleteOtherServiceOrCategory.pending)
      .addCase(deleteOtherServiceOrCategory.fulfilled, (state, action) => {
        const idToDelete = action.payload.id;

        state.otherServicesPrices = state.otherServicesPrices
          .filter(category => category.id !== idToDelete)
          .map(category => ({
            ...category,
            children:
              category.children?.filter(service => service.id !== idToDelete) ||
              [],
          }));
      })
      .addCase(deleteOtherServiceOrCategory.rejected)

      // Upload other services prices from file +
      .addCase(uploadOtherServicesPrices.pending, state => {
        state.isUploadingOtherServicesPrices = true;
      })
      .addCase(uploadOtherServicesPrices.fulfilled, (state, action) => {
        state.isUploadingOtherServicesPrices = false;
      })
      .addCase(uploadOtherServicesPrices.rejected, state => {
        state.isUploadingOtherServicesPrices = false;
      })

      // Upload parts prices from file +
      .addCase(uploadPartsPrices.pending, state => {
        state.isUploadingPartsPrices = true;
      })
      .addCase(uploadPartsPrices.fulfilled, (state, action) => {
        state.isUploadingPartsPrices = false;
      })
      .addCase(uploadPartsPrices.rejected, state => {
        state.isUploadingPartsPrices = false;
      })

      // Get data for ServicesPrices (left side) +
      .addCase(getServicesPrices.pending, handlePending)
      .addCase(getServicesPrices.fulfilled, (state, action) => {
        state.isLoading = false;

        state.pricesForDiagnostic = action.payload;
      })
      .addCase(getServicesPrices.rejected, handleRejected)

      // Add service subcategory (left side) +
      .addCase(addServicesSubcategory.pending)
      .addCase(addServicesSubcategory.fulfilled, (state, action) => {
        const { id, parent_id, ...newServiceData } = action.payload;

        const newItem = {
          id,
          parent_id,
          ...newServiceData,
          children: [], // тільки для категорій
        };

        if (parent_id === null) {
          // Це категорія — додаємо до кореневого масиву
          state.pricesForDiagnostic.push(newItem);
        } else {
          // Це послуга — додаємо в children до відповідної категорії
          const parentCategory = state.pricesForDiagnostic.find(
            category => category.id === parent_id
          );

          if (parentCategory) {
            parentCategory.children.push({
              id,
              parent_id,
              ...newServiceData,
            });
          } else {
            console.warn(
              "addServicesSubcategory: категорію з parent_id не знайдено",
              parent_id
            );
          }
        }
      })
      .addCase(addServicesSubcategory.rejected)

      // Delete subcategory or category (left side) +
      .addCase(deleteDiagnosticCategory.pending)
      .addCase(deleteDiagnosticCategory.fulfilled, (state, action) => {
        const idToDelete = action.payload.id;

        // Перевіряємо, чи це категорія — тобто об'єкт верхнього рівня
        const categoryIndex = state.pricesForDiagnostic.findIndex(
          category => category.id === idToDelete
        );

        if (categoryIndex !== -1) {
          // Якщо знайдена категорія — видаляємо її
          state.pricesForDiagnostic.splice(categoryIndex, 1);
        } else {
          // Інакше — це послуга в children, проходимо по всіх категоріях
          state.pricesForDiagnostic = state.pricesForDiagnostic.map(
            category => ({
              ...category,
              children: category.children.filter(
                service => service.id !== idToDelete
              ),
            })
          );
        }
      })
      .addCase(deleteDiagnosticCategory.rejected)

      // Update subcategory or category (left side) +
      .addCase(updateDiagnosticCategory.pending)
      .addCase(updateDiagnosticCategory.fulfilled, (state, action) => {
        const { id, name, price } = action.payload;

        // 1. Оновлення серед категорій
        const categoryIndex = state.pricesForDiagnostic.findIndex(
          cat => cat.id === id
        );

        if (categoryIndex !== -1) {
          state.pricesForDiagnostic[categoryIndex].name = name;
          return;
        }

        // 2. Оновлення серед children
        for (let cat of state.pricesForDiagnostic) {
          const childIndex = cat.children.findIndex(child => child.id === id);
          if (childIndex !== -1) {
            cat.children[childIndex].name = name;
            cat.children[childIndex].price = price;
            return;
          }
        }

        console.warn("updateDiagnosticCategory: item with id not found", id);
      })

      .addCase(updateDiagnosticCategory.rejected)

      //! RATING
      .addCase(getRatings.pending, handlePending)
      .addCase(getRatings.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(getRatings.rejected, handleRejected)

      //! MARKUP
      // Get all markups +
      .addCase(getAllMarkups.pending, handlePending)
      .addCase(getAllMarkups.fulfilled, (state, action) => {
        state.isLoading = false;

        state.markups = action.payload.items;
      })
      .addCase(getAllMarkups.rejected, handleRejected)

      // Create Markup +
      .addCase(createMarkup.pending, handlePending)
      .addCase(createMarkup.fulfilled, (state, action) => {
        state.isLoading = false;

        state.markups.push(action.payload);
      })
      .addCase(createMarkup.rejected, handleRejected)

      // Update Fixed Markup +
      .addCase(updateFixedMarkup.pending, handlePending)
      .addCase(updateFixedMarkup.fulfilled, (state, action) => {
        state.isLoading = false;
        const markupToEditIndex = state.markups.findIndex(
          markup => markup.id === action.payload.id
        );
        state.markups[markupToEditIndex] = {
          ...state.markups[markupToEditIndex], // Залишаємо старі дані
          ...action.meta.arg, // Додаємо дані, які відправляли
        };
      })
      .addCase(updateFixedMarkup.rejected, handleRejected)

      // Delete Markup +
      .addCase(deleteMarkup.pending, handlePending)
      .addCase(deleteMarkup.fulfilled, (state, action) => {
        state.isLoading = false;

        state.markups = state.markups.filter(
          markup => markup.id !== action.payload.id
        );
      })
      .addCase(deleteMarkup.rejected, handleRejected)

      //! Cash register
      // Get All Cash Registers +
      .addCase(getAllCashRegisters.pending, state => {
        state.isCashRegistersLoading = true;
      })
      .addCase(getAllCashRegisters.fulfilled, (state, action) => {
        state.isCashRegistersLoading = false;

        state.cashRegisters = action.payload;
      })
      .addCase(getAllCashRegisters.rejected, (state, action) => {
        state.isCashRegistersLoading = false;
        state.error = action.payload;
      })

      // Create cash register +
      .addCase(createCashRegister.pending, state => {
        state.isCashRegistersLoading = true;
      })
      .addCase(createCashRegister.fulfilled, (state, action) => {
        state.isCashRegistersLoading = false;
      })
      .addCase(createCashRegister.rejected, (state, action) => {
        state.isCashRegistersLoading = false;
        state.error = action.payload;
      })

      // Update cash register +
      .addCase(updateCashRegister.pending, state => {
        state.isCashRegistersLoading = true;
      })
      .addCase(updateCashRegister.fulfilled, (state, action) => {
        state.isCashRegistersLoading = false;
      })
      .addCase(updateCashRegister.rejected, (state, action) => {
        state.isCashRegistersLoading = false;
        state.error = action.payload;
      })

      // Delete Cash Register +
      .addCase(deleteCashRegister.pending, state => {
        state.isCashRegistersLoading = true;
      })
      .addCase(deleteCashRegister.fulfilled, (state, action) => {
        state.isCashRegistersLoading = false;

        state.cashRegisters = state.cashRegisters.filter(
          cashRegister => cashRegister.id !== action.payload.id
        );
      })
      .addCase(deleteCashRegister.rejected, (state, action) => {
        state.isCashRegistersLoading = false;
        state.error = action.payload;
      })

      .addCase(registerNewService.pending, handlePending)
      .addCase(registerNewService.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(registerNewService.rejected, handleRejected)

      //! Integration
      // Get Integration +
      .addCase(getIntegration.pending, handlePending)
      .addCase(getIntegration.fulfilled, (state, action) => {
        state.isLoading = false;

        state.integration = action.payload;
      })
      .addCase(getIntegration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        // 404 — інтеграції ще немає
        if (action.payload?.status === 404) {
          state.integration = {};
        }
      })

      // Create Integration +
      // api_key приходить лише у відповіді на створення — у стор його не зберігаємо
      .addCase(createIntegration.pending, handlePending)
      .addCase(createIntegration.fulfilled, (state, action) => {
        state.isLoading = false;
        const { api_key, ...integration } = action.payload;
        state.integration = integration;
      })
      .addCase(createIntegration.rejected, handleRejected)

      // Update Integration +
      .addCase(updateIntegration.pending, state => {
        state.error = null;
      })
      .addCase(updateIntegration.fulfilled, (state, action) => {
        state.isLoading = false;
        state.integration = {
          ...state.integration,
          ...action.payload,
        };
      })
      .addCase(updateIntegration.rejected, handleRejected)

      // Delete Integration +
      .addCase(deleteIntegration.pending, handlePending)
      .addCase(deleteIntegration.fulfilled, state => {
        state.isLoading = false;
        state.integration = {};
      })
      .addCase(deleteIntegration.rejected, handleRejected)

      // Test Integration +
      .addCase(testIntegration.pending, state => {
        state.error = null;
      })
      .addCase(testIntegration.fulfilled, (state, action) => {
        state.integration = {
          ...state.integration,
          last_test_at: new Date().toISOString(),
          last_test_ok: action.payload.ok,
          last_test_status_code: action.payload.status_code,
          last_test_error: action.payload.error,
        };
      })
      .addCase(testIntegration.rejected, handleRejected)

      // Reset Integration API key +
      .addCase(resetIntegrationApiKey.pending, state => {
        state.error = null;
      })
      .addCase(resetIntegrationApiKey.fulfilled, (state, action) => {
        const { api_key, ...integration } = action.payload;
        state.integration = { ...state.integration, ...integration };
      })
      .addCase(resetIntegrationApiKey.rejected, handleRejected)

      // ! LICENSE

      // get license +
      .addCase(getLicense.pending, handlePending)
      .addCase(getLicense.fulfilled, (state, action) => {
        state.isLoading = false;
        state.license = action.payload;
      })
      .addCase(getLicense.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        // 404 — інтеграції ще немає
        if (action.payload?.status === 404) {
          state.license = {};
        }
      })

      // request license key +
      .addCase(requestLicenseKey.pending, handlePending)
      .addCase(requestLicenseKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.licenseRequest = action.payload;
      })
      .addCase(requestLicenseKey.rejected, handleRejected)

      //! RECORDS
      // Delete record
      .addCase(deleteRecord.pending, handlePending)
      .addCase(deleteRecord.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(deleteRecord.rejected, handleRejected)

      // Delete all records
      .addCase(deleteAllRecords.pending, handlePending)
      .addCase(deleteAllRecords.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(deleteAllRecords.rejected, handleRejected)
});

export const {
  setEditedCategory,
  setEditedService,
  setEditedItem,
  resetEditedServices,
  openModal,
  closeModal,
  setTutorialSection,
  setSettingsPage,
  setFinishedPages,
  setLegalPersonType,
  setIsServiceAccordionExpanded,
  setIsTutorialOpen,
} = settingsSlice.actions;

export default settingsSlice.reducer;
